import React from 'react'
import ProductoExitoso from '../components/administracion/ProductoExitoso'
import "./creacionProductoExitoso.css"
export const CreacionProductoExitoso = () => {
    return (
        <div className='productoExitoso'>
            <ProductoExitoso />
        </div>
    )
}
export default CreacionProductoExitoso;
